import { render, staticRenderFns } from "./DashboardToday.vue?vue&type=template&id=33113c13&scoped=true&"
import script from "./DashboardToday.vue?vue&type=script&lang=js&"
export * from "./DashboardToday.vue?vue&type=script&lang=js&"
import style0 from "./DashboardToday.vue?vue&type=style&index=0&id=33113c13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33113c13",
  null
  
)

export default component.exports